/**
 * Created by slava on 5/3/19
 */

(function () { 
    const guessPlatformURL = function (options) {
        options = options || {};

        const config = options.config || connector.config;
        const debugMode = options.debugMode !== undefined ? options.debugMode : connector.config.debugMode;
        const source = options.source || connector.info.source;
        const isMobile = options.isMobile !== undefined ? options.isMobile : connector.info.isMobile;
        const isPlayhop = options.isPlayhop !== undefined ? options.isPlayhop : connector.info.playhop;

        let host;

        switch (source) {
            case "android":
                return config.android && `https://play.google.com/store/apps/details?id=${config.android.package}`;
            case "amazon":
                return config.amazon && `https://www.amazon.com/dp/${config.amazon.id}`;
            case "macos":
            case "ios":
                return config.ios && `https://apps.apple.com/app/id${config.ios.id}`;
            case "instant":
                return config.instant && `https://www.facebook.com/instantgames/play/${config.instant.appId}`;
            case "ok":
                return config.ok && (isMobile ? "https://m.ok.ru/game/" : "https://ok.ru/game/") + (config.ok.shortname || config.ok.appId);
            case "vk":
                host = isMobile ? "https://m.vk.ru/" : "https://vk.ru/";
                return config.vk && host + (config.vk.shortname || `app${config.vk.appId}`);
            case "mm":
                return config.mm && (isMobile ? "https://m.my.mail.ru/apps/" : "https://my.mail.ru/apps/") + config.mm.appId;
            case "mbga":
                if (debugMode) {
                    return config.mbga && `https://sb.yahoo-mbga.jp/game/${config.mbga.appId}/play`;
                }
                return config.mbga && `https://yahoo-mbga.jp/game/${config.mbga.appId}/play`;
            case "sp_mbga":
                return config.mbga && `http://sp.mbga.jp/_pf_install?game_id=${config.mbga.appId}`;
            case "draugiem":
                return config.draugiem && `https://www.draugiem.lv/${parseInt(config.draugiem.appId) ? "applications/" : ""}${config.draugiem.appId}`;
            case "fotostrana":
                return config.fotostrana && `https://fotostrana.ru/app/${config.fotostrana.appId}`;
            case "yandex":
                if (isPlayhop) {
                    return config.yandex && `https://playhop.com/app/${config.yandex.appId}`;
                }
                return config.yandex && `https://yandex.ru/games/play/${config.yandex.appId}`;
            case "gdcom":
                return config.gdcom && `https://revision.gamedistribution.com/${config.gdcom.appId}`;
            case "plng":
                return config.plinga && `https://revision.gamedistribution.com/${config.plinga.appId}`;
            case "msstart":
                return config.msstart && `https://www.msn.com/en-us/play/${(`${config.msstart.name.replaceAll(" ", "-")}/cg-${config.msstart.appId}`).toLowerCase()}`;
            case "kongregate":
                return config.kongregate && `https://www.kongregate.com/games/CleverApps/${config.kongregate.name}`;
            case "crazy":
                return config.crazy && `https://www.crazygames.com/game/${config.crazy.name}`;
            case "xsolla":
                return `${config.deployment + (debugMode ? "/publish/html5-staging/" : "/publish/html5/")}?source=cleverapps`;
            case "labsystech":
                return `${(config.ruDeployment || config.deployment) + (debugMode ? "/publish/html5-staging/" : "/publish/html5/index-ru.html")}?source=labsystech`;
            case "test":
                return config.deployment + (debugMode ? "/publish/html5-staging/" : "/publish/html5/");
            case "microsoft":
                return config.microsoft && `https://apps.microsoft.com/detail/${config.microsoft.appId}`;
            case "msix":
                return `https://cleverappssg.com/msix/${config.name}.msix`;
        }
    };

    if (typeof connector === "undefined") {
        module.exports = guessPlatformURL;
    } else {
        connector.utils.guessPlatformURL = guessPlatformURL;
    }
}());
